<template>
    <DnCheckbox class="base-checkbox">
        <slot />
    </DnCheckbox>
</template>

<script setup>
import DnCheckbox from '@digitalnatives/checkbox';
</script>

<style lang="less">
.base-checkbox {
    .dn-checkbox__custom {
        height: 1.25rem;
        width: 1.25rem;
        box-shadow: none;
        border-radius: .25rem;
        border: 1px solid var(--color-muted-gray);
        background-color: #fff;
        transform: translateY(-1px);

        &:after {
            color: var(--color-secondary);
            font-size: .8em;
            transition: transform 300ms;
        }

        &:hover, &:focus {
            border-color: var(--color-darkest);
            background-color: rgba(17, 74, 78, .1);
        }
    }

    .dn-checkbox__label {
        .typography-body();
        color: inherit;
        display: flex;
        gap: .5rem;
        margin-left: .5rem;
        user-select: none;
    }

    &.dn-checkbox input[type='checkbox']:checked + .dn-checkbox__custom {
        border-color: var(--color-secondary);
        background-color: var(--color-secondary);

        &:after {
            color: var(--color-lightest);
        }
    }

    &.dn-checkbox input[type='checkbox']:not(:checked):focus + .dn-checkbox__custom {
        border-color: var(--color-darkest);
        background-color: rgba(17, 74, 78, .1);
    }
}

@keyframes scaleIn {
    to {
        transform: scale(1);
    }
}
</style>
